import { Platform } from '@/core/Platform';
import { StyleSheet } from '@/core/StyleSheet';

export default StyleSheet.create({
	card: {
		borderColor: '#E9E9E9',
		borderRadius: 8,
		borderStyle: 'solid',
		borderWidth: 0.5,
		flexDirection: 'column',
		padding: 10,
	},
	header: {
		flex: 1,
		paddingBottom: 15,
	},
	title: {
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
	titleStart: {
		flexShrink: 1,
	},
	titleStartText: {
		fontSize: 16,
		fontWeight: '$weightBold',
		...Platform.select({
			web: {
				whiteSpace: 'normal',
			},
		}),
	},
	titleEnd: {
		flexShrink: 1,
		marginLeft: 'auto',
		paddingLeft: 5,
	},
	subtitle: {
		fontSize: 16,
		...Platform.select({
			web: {
				whiteSpace: 'normal',
			},
		}),
	},
	content: {
		flex: 1,
	},
});
